<template>
  <el-form :model="group" label-width="80px" :loading="loading">
    <el-form-item label="分组名称" required>
      <el-input placeholder="请输入名称" v-model="group.name"/>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" v-model="group.remark" multiline/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitSaveAction">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {add, update} from './groupApi'

export default {
  name: 'addOrEditGroup',
  data () {
    return {
      loading: false,
      group: {
        name: '',
        remark: ''
      },
      addOrEdit: true
    }
  },
  props: {
    groupData: {
      name: '',
      remark: ''
    }
  },
  created () {
    console.log(this.groupData)
    if (this.groupData !== undefined && this.groupData !== null) {
      const copy = JSON.parse(JSON.stringify(this.groupData))
      const { customerGroupId } = copy
      this.addOrEdit = customerGroupId === undefined
      this.group = copy
    }
  },
  watch: {
    groupData (d) {
      const copy = JSON.parse(JSON.stringify(d))
      const { customerGroupId } = copy
      this.addOrEdit = customerGroupId === undefined
      this.group = copy
      console.log(d)
    }
  },
  methods: {
    submitSaveAction () {
      if (this.addOrEdit === true) {
        this.submitAddAction()
      } else {
        this.submitUpdateGroup()
      }
    },
    submitAddAction () {
      const name = this.group.name.trim()
      if (name.length === 0) {
        this.$message.error('姓名不能为空')
        return
      }
      this.loading = true
      add(this.group).then(rsp => {
        this.loading = false
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('添加成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submitUpdateGroup () {
      this.loading = true
      update(this.group).catch(() => {
        this.loading = false
      }).then((rsp) => {
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('修改成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerGroup/addOrEditGroup.vue